// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"c2d44e","breadcrumbs__list":"c1e96e","breadcrumbs__item":"_7744de","breadcrumbs__link":"_5d9669","breadcrumbs__text":"_50ba83","breadcrumbs__separator":"_70ad16"};